import { ICodConfirmConfig } from 'app-components';
import i18n from '@/i18n'

const t = i18n.global.t

export interface IAlertButton {
  text: string
  handler?: () => any
}

// showAlert is callable outside setup (composables, services), so it cannot
// inject() the CodConfirm dispatcher — MainLayout registers it here instead.
let alertHost: ((config: ICodConfirmConfig) => void) | null = null

export function registerAlertHost(host: (config: ICodConfirmConfig) => void) {
  alertHost = host
}

export function showAlert(header: string, message?: string, buttons: IAlertButton[] = []) {
  message = message ? (t(message) === message ? message : t(message)) : undefined
  message = header !== message ? message : undefined

  // An alert shows exactly its buttons — never CodConfirm's default "Poništi"
  // beside them — and a tap outside closes it, as v8's alert did. That close
  // runs no handler: the flow that asked simply stops (the card-read question
  // leaves its payment unissued and the order as it was).
  const config: ICodConfirmConfig = { title: header, message, buttonCancelText: '' }

  if (!buttons.length) {
    config.buttonTrueText = t('general.close')
  } else if (buttons.length === 1) {
    config.buttonTrueText = buttons[0].text
    config.yesHandler = () => buttons[0].handler?.()
  } else {
    // Both buttons are answers — Ne on the card-read question issues the receipt
    // without the terminal — so neither is focused when the alert opens, as in
    // v8: an Enter from a terminal's OK key or a scanner must not answer it.
    config.focusSheetOnOpen = true
    config.buttonFalseText = buttons[0].text
    config.noHandler = () => buttons[0].handler?.()
    config.buttonTrueText = buttons[1].text
    config.yesHandler = () => buttons[1].handler?.()
  }

  if (!alertHost) {
    console.error('[showAlert] no alert host registered — alert dropped:', header)
    return
  }

  alertHost(config)
}
